export default "__VITE_ASSET__LJCE$Tyg__"